/**
 * Created by Ivan on 13.04.2024
 */

const PredictionManager = function () {
    this.load();

    this.initPredictionsEvents(connector.EVENTS.PREDICTIONS);
};

// stops the prediction events for the rest of the install
PredictionManager.prototype.disable = function () {
    this.disabled = true;
};

PredictionManager.prototype.load = function () {
    const saved = connector.dataLoader.load(SimpleDataLoader.TYPES.MULTIPLE_PREDICTIONS_INFO)
        || connector.dataLoader.load(SimpleDataLoader.TYPES.MULTIPLE_CONVERSIONS_INFO) || {};

    this.events = saved.events || saved;
};

PredictionManager.prototype.save = function () {
    connector.dataLoader.save(SimpleDataLoader.TYPES.MULTIPLE_PREDICTIONS_INFO, this.getData());
};

PredictionManager.prototype.getData = function () {
    return {
        events: this.events
    };
};

PredictionManager.prototype.processPrediction = function (prediction, amount) {
    if (this.disabled) {
        return;
    }

    if (Array.isArray(prediction)) {
        prediction.forEach(function (one) {
            this.processPrediction(one, amount);
        }, this);
        return;
    }

    if (connector.metrics.getDaysSinceRegistration() >= prediction.conversion_window) {
        return;
    }

    const day = `d${prediction.conversion_window}`;

    if (prediction.reach && prediction.reach.includes(amount)) {
        this.logReachEvent(`${day}r_${prediction.name}_${amount}`);
    }

    if (prediction.accumulate) {
        this.logReachEvent(`${day}a_${prediction.name}#`);
        this.logAccumulateEvent(`${day}a_${prediction.name}`, prediction.accumulate === "count" ? 1 : amount);
    }
};

PredictionManager.prototype.logReachEvent = function (event) {
    if (!this.events[event]) {
        this.events[event] = 1;
        this.save();

        const params = {
            event: connector._metrics.registered,
            channel: connector._metrics.channel,
            value: 1,
            conversion: true
        };
        
        connector.metrics.logEvent(event, params);
    }
};

PredictionManager.prototype.logAccumulateEvent = function (event, amount) {
    const params = {
        event: connector._metrics.registered,
        channel: connector._metrics.channel,
        value: amount,
        conversion: true
    };
    
    connector.metrics.logEvent(event, params);
};

PredictionManager.prototype.logDay1Dau = function () {
    if (this.disabled) {
        return;
    }

    if (connector.platform.oneOf(connector.MICROSOFT) && connector._metrics.channel) {
        connector.platform.getPlugin().bus.trigger(
            "stream:console", 
            "MICROSOFT_CHANNEL",
            `${connector.config.name} ${connector.platform.getUserID()} ${connector._metrics.channel} trigger d1_dau`
        );
    }

    connector.metrics.logEvent("d1_dau", {
        event: connector._metrics.registered,
        channel: connector._metrics.channel,
        value: 1,
        conversion: true
    });
};

PredictionManager.prototype.initPredictionsEvents = function (predictionEvents) {
    const giveName = (conf, normalizedName) => {
        if (Array.isArray(conf)) {
            conf.forEach((item) => giveName(item, normalizedName));
        } else if (conf && typeof conf === "object") {
            conf.name = normalizedName;
        }
    };

    for (const [key, value] of Object.entries(predictionEvents)) {
        const normalizedName = key.toLowerCase().replace(/_/g, "");
        giveName(value, normalizedName);
    }
};
